import { Component, Vue, Inject, Prop } from 'vue-property-decorator';
import Utilidades from '@/shared/config/utilidades';
import AlertService from '@/shared/alert/alert.service';
import { IResumenPagosAnual } from '@/shared/model/exbecarios/resumen-pagos-anual.model';
import PagoService from '@/entities/seguimiento/financiero/pago.service';
import { BvTableFieldArray } from 'bootstrap-vue';
import PersonalBecaService from '@/entities/seguimiento/personal-beca.service';
import { CartaNoAdeudo, ICartaNoAdeudo } from '@/shared/model/exbecarios/carta-no-adeudo.model';
import CartaConclusionService from '@/entities/exbecarios/carta-conclusion.service';
import { TipoCartaConclusion } from '@/shared/model/enumerations/tipo-carta-conclusion.model';
import { CartaConclusion } from '@/shared/model/exbecarios/carta-conclusion.model';
import EventoCartaConclusionService from '@/entities/exbecarios/evento-carta-conclusion.service';
import { FiltroCartaConclusion } from '@/shared/model/filtro.model';

@Component({
  computed: {
    totalGeneralFormateado() {
      return this.utilidades.formatearMonto(parseFloat(this.totalGeneral)) + ' M.N';
    },
  },
})
export default class ResumenPagosComponent extends Vue {
  @Inject('pagoService') private readonly pagoService: () => PagoService;
  @Inject('alertService') private readonly alertService: () => AlertService;
  @Inject('personalBecaService') public readonly personalBecaService: () => PersonalBecaService;
  @Inject('cartaConclusionService') private readonly cartaConclusionService: () => CartaConclusionService;
  @Inject('eventoCartaConclusionService') private readonly eventoCartaConclusionService: () => EventoCartaConclusionService;

  @Prop({ required: true })
  public idBeca!: string;

  public cartaConclusion: CartaConclusion | null = null;

  public isSearching = false;
  public indicadorCargaShow = false;
  public propOrder = 'createdDate';
  public reverse = true;
  public mensajeCarga = this.$t('indicadorCarga.guardando', {
    mensaje: this.$t('apeironGwApp.resumenPagos.mensaje.informacion'),
  }).toString();
  public readonly campos: BvTableFieldArray = [
    {
      key: 'anio',
      label: this.$t('apeironGwApp.resumenPagos.tabla.anio').toString(),
      class: 'font-weight-bold',
    },
    {
      key: 'montoApoyoEconomico',
      label: this.$t('apeironGwApp.resumenPagos.tabla.apoyoEconomico').toString(),
      class: 'text-right',
      formatter: (value: number) => this.utilidades.formatearMonto(value),
    },
    {
      key: 'monedaApoyoEconomico',
      label: this.$t('apeironGwApp.resumenPagos.tabla.monedaApoyo').toString(),
      class: 'text-center',
    },
  ];
  public utilidades = new Utilidades();
  public pagos: Array<IResumenPagosAnual> = [];
  public totalApoyo = 0;
  public totalGeneral = 0;
  public totalModificado = 0;
  public totalGeneralFormateado: string;
  public cartaNoAdeudo: ICartaNoAdeudo = new CartaNoAdeudo();

  public mounted(): void {
    this.indicadorCargaShow = true;

    this.retrieveCartaConclusion()
      .then(res => {
        this.cartaConclusion = res?.data?.[0] ?? null;
      })
      .catch(err => {
        this.alertService().showHttpError(this, err.response);
        this.cartaConclusion = null;
      })
      .finally(() => {
        this.retrievePagos();
        this.indicadorCargaShow = false;
      });
  }

  /**
   * Recupera el historial de pagos con base en el identificador de la beca
   */
  public retrievePagos(): void {
    this.isSearching = true;

    this.pagoService()
      .obtenerResumenPagosAnual(this.idBeca)
      .then(result => {
        this.pagos = result?.data ?? [];

        const suma = this.pagos.reduce((acc, p) => {
          return acc + Number(p.montoApoyoEconomico ?? 0);
        }, 0);

        this.totalApoyo = suma;
        this.totalGeneral = suma;
        this.totalModificado = suma;

        const tipo = this.cartaConclusion?.tipo ?? null;

        if (tipo === TipoCartaConclusion.CARTA_NO_ADEUDO && this.cartaConclusion) {
          const c = this.cartaConclusion as ICartaNoAdeudo;

          this.totalApoyo = Number(c.totalApoyo ?? suma);
          this.totalGeneral = Number(c.totalGeneral ?? suma);
          this.totalModificado = Number(c.totalModificado ?? suma);
        }
      })

      .catch(error => {
        if (error.response.status !== 404) {
          this.alertService().showHttpError(this, error.response);
        }
      })
      .finally(() => {
        this.isSearching = false;
      });
  }
  /**
   * Obtiene la carta conclusion por el id de la beca
   * @returns
   */
  public retrieveCartaConclusion(): Promise<any> {
    const filtro = new FiltroCartaConclusion();
    filtro.becaId = this.idBeca;
    const page = 0;
    const itemsPerPage = 5;
    const paginationQuery = {
      page: page,
      size: itemsPerPage,
      sort: this.sort(),
      filter: filtro,
    };
    return this.cartaConclusionService().retrieve(paginationQuery);
  }

  private sort(): string[] {
    const result = [this.propOrder + ',' + (this.reverse ? 'desc' : 'asc')];
    if (this.propOrder !== 'id') {
      result.push('id');
    }
    return result;
  }
}
